import TagGrantsList from './views/TagGrantList'
import TagGrantEdit from './views/TagGrantEdit'
import TagGrantCreate from './views/TagGrantCreate'

export default {
  name:"taggrants",
  list:TagGrantsList,
  edit:TagGrantEdit,
  create:TagGrantCreate,
}